export default "__VITE_ASSET__Z$XOfDU7__"